import { Link } from 'react-router-dom';
import { aboutInfo } from '@/mocks/comics';

export default function About() {
  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "韩国漫画网",
    "url": "https://www.koreanmanhwa.cn/",
    "description": "韩国漫画网 - 好看的韩国漫画在线免费阅读平台",
    "foundingDate": "2023",
    "contactPoint": {
      "@type": "ContactPoint",
      "contactType": "customer service",
      "email": "contact@koreanmanhwa.cn",
      "availableLanguage": ["Chinese"]
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "首页",
        "item": "https://www.koreanmanhwa.cn/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "关于我们",
        "item": "https://www.koreanmanhwa.cn/about"
      }
    ]
  };

  const pageSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    "name": "关于韩国漫画网",
    "description": aboutInfo.intro,
    "url": "https://www.koreanmanhwa.cn/about"
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(pageSchema) }}
      />

      <header className="pt-24 pb-8 md:pt-28 md:pb-12 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-4" aria-label="面包屑导航">
            <Link to="/" className="hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
            <i className="ri-arrow-right-s-line text-xs"></i>
            <span className="text-foreground-800">关于我们</span>
          </nav>
          <h1 className="text-3xl md:text-4xl font-bold text-foreground-950 font-heading">
            关于<span className="text-primary-600">韩国漫画网</span>
          </h1>
          <p className="text-foreground-500 mt-3 max-w-2xl">
            {aboutInfo.slogan}
          </p>
        </div>
      </header>

      <section className="py-12 md:py-16 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="max-w-3xl mx-auto text-center mb-14">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-5">
              品牌<span className="text-primary-600">介绍</span>
            </h2>
            <p className="text-foreground-600 leading-relaxed">
              {aboutInfo.intro}
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-16">
            {aboutInfo.features.map((feature, index) => (
              <div key={index} className="p-6 rounded-lg bg-background-50 border border-background-200/70 transition-all hover:border-primary-200">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 mb-4">
                  <i className="ri-check-line text-primary-600 text-lg"></i>
                </div>
                <h3 className="text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
              用户口碑
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              读者们的<span className="text-primary-600">真实评价</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {aboutInfo.testimonials.map((testimonial, index) => (
              <div key={index} className="p-6 rounded-lg bg-background-100 border border-background-200/70">
                <div className="flex items-center gap-1 mb-3">
                  {Array.from({ length: testimonial.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-500 text-sm"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                  &ldquo;{testimonial.text}&rdquo;
                </p>
                <p className="text-xs font-medium text-foreground-800">— {testimonial.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="max-w-2xl mx-auto text-center">
            <span className="inline-block px-4 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3">
              联系我们
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-10">
              与我们<span className="text-primary-600">取得联系</span>
            </h2>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 mx-auto mb-3">
                  <i className="ri-mail-line text-primary-600 text-lg"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                <p className="text-xs text-foreground-500">contact@koreanmanhwa.cn</p>
              </div>
              <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 mx-auto mb-3">
                  <i className="ri-wechat-line text-primary-600 text-lg"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">微信公众号</h3>
                <p className="text-xs text-foreground-500">韩国漫画网</p>
              </div>
              <div className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 mx-auto mb-3">
                  <i className="ri-weibo-line text-primary-600 text-lg"></i>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 mb-1">官方微博</h3>
                <p className="text-xs text-foreground-500">@韩国漫画网官方</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-12 md:py-16 bg-background-50">
        <div className="max-w-2xl mx-auto px-4 md:px-6">
          <div className="text-center mb-8">
            <h2 className="text-2xl font-bold text-foreground-950 font-heading">
              给我们<span className="text-primary-600">留言</span>
            </h2>
          </div>

          <form className="space-y-4" data-readdy-form="" action="https://readdy.ai/api/form/d9osvh0senbniolesl9g" method="POST">
            <div>
              <input
                type="text"
                name="name"
                placeholder="您的姓名"
                className="w-full px-4 py-3 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                required
              />
            </div>
            <div>
              <input
                type="email"
                name="email"
                placeholder="您的邮箱"
                className="w-full px-4 py-3 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
                required
              />
            </div>
            <div>
              <textarea
                name="message"
                placeholder="请描述您的意见或建议..."
                rows={4}
                maxLength={500}
                className="w-full px-4 py-3 text-sm rounded-lg border border-background-200 bg-background-50 text-foreground-800 placeholder-foreground-400 focus:outline-none focus:border-primary-400 transition-colors resize-none"
                required
              ></textarea>
            </div>
            <div className="anti-spam-field">
              <input type="text" name="website_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
            </div>
            <button
              type="submit"
              className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-white text-sm font-medium rounded-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              发送留言
            </button>
          </form>
        </div>
      </section>
    </>
  );
}